// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
	name: "addLeadingZero",
	standalone: false,
})
export class AddLeadingZeroPipe implements PipeTransform {
	transform(value: string | number, ...args: unknown[]): string {
		let valueAsNumber: number = Number(value);
		if (isNaN(valueAsNumber)) {
			return value + "";
		} else {
			if (valueAsNumber <= 9) {
				return "0" + value;
			} else {
				return value + "";
			}
		}
	}
}
